import { TAddBusinessAccountForm, TBusinessDetails } from './types'

export const businessDetailsInitialValues: TBusinessDetails = {
  uuid: '',
  verification_status: null,
  legal_business_name: '',
  moov_account_id: '',
  pending_creation_bank_accounts_counter: 0
}

export const initialValues: TAddBusinessAccountForm = {
  legal_business_name: '',
  consent: false
}
